module.exports = __webpack_public_path__ + "img/paypal.78ca0767.svg";